import { Mode } from '@ocean/types/dist/appearance'
import { common } from '@ocean/ui'
import { useSelector } from 'hooks'
import { GlobalLoadingContext } from 'core/contexts'

const { Spinner } = common

const GlobalLoadingLayer: React.FC = ({ children }) => {
  const isGlobalLoading = useSelector(({ globalLoading }) => globalLoading.isGlobalLoading)

  return (
    <GlobalLoadingContext.Provider value={isGlobalLoading}>
      {isGlobalLoading && <Spinner global mode={Mode.Light} />}
      {children}
    </GlobalLoadingContext.Provider>
  )
}

export default GlobalLoadingLayer
